import { render, staticRenderFns } from "./SithMesSapHandleRecordEdit.vue?vue&type=template&id=787c6dba&"
import script from "./SithMesSapHandleRecordEdit.vue?vue&type=script&lang=js&"
export * from "./SithMesSapHandleRecordEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports